export default function Counter(){
    return (
        <div className="counter-strong">
        <div className="container">
          <div className="row">
            <div className="four col-md-3">
              <div className="counter-box colored">
                <div className="counter-time">
                  <span className="counter">20</span>
                  <h3>+</h3>
                </div>
                <p>Experts</p>
              </div>
            </div>
            <div className="four col-md-3">
              <div className="counter-box">
                <div className="counter-time">
                  <span className="counter">50</span>
                  <h3>+</h3>
                </div>
                <p>Mobile Applications</p>
              </div>
            </div>
            <div className="four col-md-3">
              <div className="counter-box">
                <div className="counter-time">
                  <span className="counter">100</span>
                  <h3>+</h3>
                </div>
                <p>Clients</p>
              </div>
            </div>
            <div className="four col-md-3">
              <div className="counter-box">
                <div className="counter-time">
                  <span className="counter">200</span>
                  <h3>+</h3>
                </div>
                <p>Total Projects</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
}